import { confirmAction, getVueApp, notifySuccess, notifyError, notifyInfo, notifyMessage } from 'app-core/config';
import { emitNotification } from 'app-core/signalr';
import { getExternalApi, postExternalApi, getUtcDate } from 'app-core/Data';
import auth from 'auth';

let incomingRequests = {};
let waitingResponses = {};
let timer = 15;

function requestCreativeAccess(creative) {
	emitNotification([creative.JsonConfig.editingLock.userId], 'request-creative-access', {
		creativeId: creative.Oid,
		creativeName: creative.Name,		
		userId: auth.userId(),
		userName: auth.displayUserName(),
	})
	waitingResponses[creative.Oid] = {
		autoUnblock: setTimeout(() => unblockCreative(creative.Oid, creative.Name), (timer + 2) * 1000)
	}
	notifyInfo(getVueApp().$tCaption(`Request has been sent. If user won\'t response in <TIMEOUT> seconds creative automatically will be unblocked.`.replace(/<TIMEOUT>/g, timer), '@Creative'));
}

async function processDenyCreativeAccess(eventName, data) {
	if (waitingResponses[data.creativeId]) {
		clearWaitingResponse(data.creativeId);
		notifyError(getVueApp().$tCaption('Access request to "<CREATIVENAME>" creative has been dismissed', '@Creative').replace(/<CREATIVENAME>/g, data.creativeName));
	}
}

async function processGrantCreativeAccess(eventName, data) {
	if (waitingResponses[data.creativeId]) {
		unblockCreative(data.creativeId, data.creativeName);
		notifySuccess(getVueApp().$tCaption('You have granted access to "<CREATIVENAME>"', '@Creative').replace(/<CREATIVENAME>/g, data.creativeName));
	}
}

function clearWaitingResponse(creativeId) {
	if (waitingResponses[creativeId]) {
		clearTimeout(waitingResponses[creativeId].autoUnblock);
		delete waitingResponses[creativeId];
	}
}

async function unblockCreative(creativeId, creativeName) {
	if (waitingResponses[creativeId]) {
		clearWaitingResponse(creativeId);
		notifyMessage(getVueApp().$tCaption('Creative <NAME> has been unblocked.', '@Creative').replace(/<NAME>/g, creativeName))
		const JSON = await getExternalApi('Creative/GetCreativeJson', `creativeId=${creativeId}`);
		JSON.editingLock = {
			utcTimestamp: getUtcDate(),
			userId: auth.userId(),
			userName: auth.displayUserName()
		};
		await postExternalApi('Creative/UpdateCreativeJson', {
			Oid: creativeId,
			JsonConfig: JSON
		});
		getVueApp().$eventsBus.$emit('received-creative-access', { creativeId, creativeName });
	}
}

async function processReceiveCreativeAccessRequest(eventName, data) {
	const app = getVueApp();
	if (incomingRequests[data.creativeId]) return;
	
	incomingRequests[data.CreativeId] = true;

	let result = true;
	await confirmAction(
		app.$tCaption('Creative access request', '@Creative'),
		app.$tCaption('User "<USERNAME>" requesting access to creative "<CREATIVENAME>". If you working on that creative please dismiss that action.'
			.replace(/<USERNAME>/g, data.userName)
			.replace(/<CREATIVENAME>/g, data.creativeName), 
		'@Creative'),
		{
			timeout: timer,
			buttons: [{
				text: getVueApp().$tCaption('Dismiss', '@actions'),
				type: 'danger',
				onClick: () => {
					result = false;
					return true;
				}
			},
			{
				text: getVueApp().$tCaption('Grant access', '@actions'),
				type: 'success',
				onClick: () => {
					result = true;
					return true;
				}
			}]
		}
	).finally(() => delete incomingRequests[data.CreativeId]);

	if (!result) {
		emitNotification([data.userId], 'deny-creative-access', {
			creativeId: data.creativeId,
			creativeName: data.creativeName,
			userId: auth.userId(),
			userName: auth.displayUserName()
		});
	} else {
		emitNotification([data.userId], 'grant-creative-access', {
			creativeId: data.creativeId,
			creativeName: data.creativeName,
			userId: auth.userId(),
			userName: auth.displayUserName()
		});
		getVueApp().$eventsBus.$emit('granted-to-other-user-creative-access', data);
	}
}

function processRequestCreativeAccess(eventName, data) {
	if (eventName === 'request-creative-access') {
		processReceiveCreativeAccessRequest(eventName, data);
		return true;
	}

	if (eventName === 'deny-creative-access') {
		processDenyCreativeAccess(eventName, data);
		return true;
	}

	if (eventName === 'grant-creative-access') {
		processGrantCreativeAccess(eventName, data);
		return true;
	}

	return false;
}

export default {
	processReceiveCreativeAccessRequest,
	processGrantCreativeAccess,
	processDenyCreativeAccess,
	processRequestCreativeAccess,
	requestCreativeAccess
}

export {
	processReceiveCreativeAccessRequest,
	processGrantCreativeAccess,
	processDenyCreativeAccess,
	processRequestCreativeAccess,
	requestCreativeAccess
}

